import React from 'react';
import Label from "../../UI/Label";
import { trackPropTypes, tracksWidth, arrowWidth } from "../../../config/defaults";
import { getLabelColorByStateAndDifficulty, getTrackColorByStateAndDifficulty } from "../../../helpers/map";
import { TRACK_DIFFICULTY_BLACK } from "../../../config/constants";
import TrackArrow from "../../UI/TrackArrow";

const Track22ABlack = ({ state, workState, onLabelClick }) => (
	<g id="Track22ABlack" transform="translate(2060.000000, 1184.000000)" className="track">
		<g id="line" transform="translate(0.921595, 0.000000)"
			 stroke={getTrackColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_BLACK)} strokeLinecap="round"
			 strokeWidth={tracksWidth}
		>
			<path
				d="M15.078405,235 C5.70364474,203.302492 13.3881125,169.011012 35.3934004,144.345542 L70.2557344,105.268759 C73.9218718,101.159428 77.2422936,96.7542784 80.1831294,92.0982452 L93.1840558,71.514728 L93.1840558,71.514728"/>

			<line x1="99.2149972" y1="62.3960573" x2="139.078405" y2="0.291045453"/>

			<TrackArrow
				transform="translate(100.522876, 60.319968) rotate(-62.000000) translate(-100.522876, -60.319968) "
				points="104.522876 68.3199678 96.5228756 60.3199678 104.522876 52.3199678"/>
		</g>

		<Label
			onClick={(event, ref) => onLabelClick(event, ref, 'Track22ABlack')}
			coords="38.000000, 101.000000"
			text="22A"
			textCoordsX="6.91650391"
			colors={getLabelColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_BLACK)}
		/>
	</g>
);

Track22ABlack.propTypes = trackPropTypes;

export default Track22ABlack;
